import "react-quill/dist/quill.snow.css";

import { Button, Modal } from "antd";
import { FC, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ReactQuill from "react-quill";
import DisabledContext from "antd/es/config-provider/DisabledContext";

import { useDescriptionField } from "./hooks";
import { EventDescriptionFieldProps } from "./types";
import * as Styled from "./styles";

// TODO: make it reusable by moving it to `src/components/fields/DescriptionField`
const EventDescriptionField: FC<EventDescriptionFieldProps> = (props) => {
  const disabledContextValue = useContext(DisabledContext);
  const { disabled, placeholder } = props;
  const {
    onModalCancel,
    onModalConfirm,
    openModal,
    showDescriptionModal,
    description,
    onDescriptionChange,
  } = useDescriptionField(props);
  const intl = useIntl();
  const disabledValue =
    disabled !== undefined ? disabled : disabledContextValue;

  return (
    <DisabledContext.Provider value={disabledValue}>
      <Button type="primary" onClick={openModal} disabled={false}>
        <FormattedMessage defaultMessage="Edit" />
      </Button>
      <Modal
        title={
          placeholder ||
          intl.formatMessage({
            defaultMessage: "Description",
          })
        }
        cancelButtonProps={{
          disabled: false,
        }}
        open={showDescriptionModal}
        onOk={onModalConfirm}
        onCancel={onModalCancel}
      >
        <Styled.QuillWrapper $disabled={disabledValue}>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={onDescriptionChange}
          />
        </Styled.QuillWrapper>
      </Modal>
    </DisabledContext.Provider>
  );
};

export default EventDescriptionField;
